import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../shared/shared.module'
import { AngularSvgIconModule, SvgIconRegistryService } from 'angular-svg-icon'
import { FontAwesomeVendorModule } from '../shared/vendors/font-awesome.vendor.module'
import { AppComponent } from './components/app/app.component'
import { HeaderComponent } from './components/header/header.component'
import { MobileSidenavComponent } from './components/mobile-sidenav/mobile-sidenav.component'
import { ScopeComponent } from './components/scope/scope.component'
import { ShellComponent } from './components/shell/shell.component'
import { DomainNameTransitionDialogComponent } from './components/domain-name-transition-dialog/domain-name-transition-dialog.component'
import { CoreRoutingModule } from './core-routing.module'
import { AppConfigService } from './services/app-config.service'
import { SecurityInterceptor } from './services/http.security.interceptor'
import * as Locale from './utils/locale'
import * as Language from './utils/language'
import { loadTranslations } from '@angular/localize'

import { icons } from './svg-icons'

@NgModule({
  declarations: [
    AppComponent,
    ShellComponent,
    HeaderComponent,
    MobileSidenavComponent,
    ScopeComponent,
    DomainNameTransitionDialogComponent
  ],
  imports: [
    SharedModule,
    CoreRoutingModule,
    FontAwesomeVendorModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([]),
    AngularSvgIconModule.forRoot()
  ],
  bootstrap: [ AppComponent ],
  providers: [
    { provide: LOCALE_ID, useFactory: Locale.fromBrowserPreference },
    {
      provide   : APP_INITIALIZER,
      deps      : [ AppConfigService, LOCALE_ID ],
      useFactory: (appConfigService: AppConfigService, angularLocaleId: Locale.AngularSupportedLocale) => async () =>{
        const selectedLanguage = Language.resolve()
        await Promise.all([
          appConfigService.init(),
          Locale.loadData(angularLocaleId),
          Language.importTranslations(selectedLanguage).then(loadTranslations),
          //load locale associated to selected language (needed to have NgBootstrap DatePicker language consistent with selected language)
          Locale.loadData(selectedLanguage)
        ])
      },        
      multi: true,
    },
    {
      provide : HTTP_INTERCEPTORS,
      useClass: SecurityInterceptor,
      multi   : true
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor (
    private svgIconRegistry : SvgIconRegistryService
  ) {
    Object.entries(icons).forEach(([ name, data ])=>this.svgIconRegistry.addSvg(name, data))
  }
}
